// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wlec","inner":"Footer_inner__cILRH","nextIcon":"Footer_nextIcon__1moAQ","innerLeft":"Footer_innerLeft__1yZwV"};